import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'
import vuetify from './plugins/vuetify'
import './assets/scss/customStyle.scss'
import filters from './filters'
import axios from 'axios'
import VueMoment from 'vue-moment'
import firebase from 'firebase/app'
import 'firebase/firestore'

// Moment JS config
const moment = require('moment')
require('moment/locale/pt-br')
Vue.use(VueMoment, {
  moment
})

Vue.config.productionTip = false

router.beforeEach((to, from, next) => {
  // Set error page to null
  store.commit('SET_ERROR_PAGE', null)

  // If route didnt need auth
  if (to.meta && to.meta.noAuth) {
    next()
  } else {
    // Verify if user is logged
    store.dispatch('isLogged')
      .then(() => {
        next()
      })
      .catch(() => {
        next({ name: 'login' })
      })
  }
})

axios.defaults.baseURL = process.env.VUE_APP_BASE_API_URL
axios.defaults.headers.post['Content-Type'] = 'application/json'

axios.interceptors.request.use(function (request) {
  if (!router.history.current.meta || !router.history.current.meta.noAuth) {
    if (!request.params) request.params = {}
    if (request.baseURL === process.env.VUE_APP_BASE_API_URL && request.url.search('heppi-support') < 0) request.params.api_token = store.getters.api_token
  }
  return request
}, function (error) {
  return Promise.reject(error)
})

axios.interceptors.response.use(function (response) {
  return response
}, function (error) {
  let noNeedAuth = router.history.current.meta && router.history.current.meta.noAuth
  let no404Page = router.history.current.meta && router.history.current.meta.no404Page

  if (error.response.config.baseURL === process.env.VUE_APP_BASE_API_URL) {
    if (error.response && error.response.status === 401 && !noNeedAuth) {
      store.dispatch('logout')
    } else if (error.response && error.response.status === 404 && !no404Page) {
      store.commit('SET_ERROR_PAGE', '404')
    } else if (error.response && error.response.status !== 401 && error.response && error.response.status !== 400 && error.response.status !== 404 && error.response.status !== 422) {
      store.commit('SET_ERROR_PAGE', '500')
    } else {
      return Promise.reject(error)
    }
  } else {
    return Promise.reject(error)
  }
})

// Your web app's Firebase configuration
var firebaseConfig = {
  apiKey: 'AIzaSyDzf3HyI_pKsMqL08nf22BAcWnKQWKHzE0',
  authDomain: 'heppi-support-accc2.firebaseapp.com',
  projectId: 'heppi-support-accc2',
  storageBucket: 'heppi-support-accc2.appspot.com',
  messagingSenderId: '302670845003',
  appId: '1:302670845003:web:87fed38d7ead520db5e9ce'
}
// Initialize Firebase
firebase.initializeApp(firebaseConfig)
Vue.prototype.$firebase = firebase
Vue.prototype.$firestore = firebase.firestore()
Vue.prototype.$http = axios

new Vue({
  router,
  store,
  vuetify,
  filters,
  render: h => h(App)
}).$mount('#app')
